import { twMerge } from '../../../utils/twmerge'

import { useButtonStyle } from './useButtonStyle'

type ButtonProps = {
  text?: string | number
  size?: 's' | 'm' | 'l'
  full?: boolean
  fill?: boolean
  gold?: boolean
  square?: boolean
  simple?: boolean
  simpleselected?: boolean
  thin?: 'gold' | 'pink' | 'gray' | 'none'
  type?: 'button' | 'submit'
  arrow?: 'bottom' | 'left' | 'top' | 'right'
  className?: string
  onClick: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void
  onHover?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void
  children?: React.ReactNode // childrenを追加
  disabled?: boolean
}

export function Button({
  text = '',
  size = 'm',
  full = false,
  fill = false,
  gold = false,
  square = false,
  simple = false,
  simpleselected = false,
  thin = 'none',
  type = 'button',
  arrow = undefined,
  className = '',
  onClick,
  onHover = () => {},
  children = null, // childrenを受け取る
  disabled = false,
}: ButtonProps) {
  const {
    buttonSizeStyle,
    widthFullStyle,
    backgroundFillStyle,
    colorGoldStyle,
    roundedSquareStyle,
    simpleStyle,
    simpleSelectedStyle,
    thinStyle,
    arrowDirectionStyle,
  } = useButtonStyle({
    size,
    full,
    fill,
    gold,
    square,
    simple,
    simpleselected,
    thin,
    arrow,
  })

  return (
    <button
      type={type}
      className={twMerge(
        'sq-btn',
        buttonSizeStyle,
        widthFullStyle,
        backgroundFillStyle,
        colorGoldStyle,
        roundedSquareStyle,
        simpleStyle,
        simpleSelectedStyle,
        thinStyle,
        className
      )}
      onClick={onClick}
      onMouseEnter={onHover}
      disabled={disabled}
    >
      <div
        className={`relative z-10 flex items-center justify-center gap-x-1.5 ${arrowDirectionStyle}`}
      >
        {children ?? text}
      </div>
    </button>
  )
}
